import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

const tabs = [
  { to: "/settings/profile", label: "Profile" },
  { to: "/settings/workspace", label: "Workspace" },
  { to: "/settings/connectors", label: "Connectors" },
  { to: "/settings/skills", label: "Skills" },
  { to: "/settings/memory", label: "Memory" },
] as const;

const tabClass =
  "rounded-none border-b-2 border-transparent bg-transparent px-3 pb-2.5 text-control text-muted-foreground transition-colors hover:text-foreground data-[status=active]:border-foreground data-[status=active]:text-foreground";

function SettingsLayout() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto min-w-0 max-w-4xl px-4 py-6 sm:px-6 sm:py-8 min-[80rem]:px-8 min-[80rem]:py-12">
        <div className="space-y-6 @container">
          <header className="space-y-2">
            <h1 className="text-headline text-foreground">Settings</h1>
            <p className="text-body text-muted-foreground">Customize how LATO works for you</p>
          </header>
          <nav className="flex w-full justify-start gap-1 overflow-x-auto border-b border-border/60">
            {tabs.map((t) => (
              <Link key={t.to} to={t.to} className={tabClass}>
                {t.label}
              </Link>
            ))}
          </nav>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_auth/_agents/settings")({
  component: SettingsLayout,
});
